"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowLeft } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";

export default function Error() {
  const t = useTranslations("error_page");

  return (
    <main className="flex flex-1 items-center justify-center px-4 py-16">
      <div className="flex max-w-md flex-col items-center text-center">
        {/* TODO: Replace this with an error-specific image instead of reusing the 404 not found illustration. */}
        <Image
          src="/assets/images/404.png"
          alt={t("image_alt")}
          width={260}
          height={220}
          priority
          className="h-auto w-[220px] sm:w-[260px]"
        />
        <h1 className="mt-6 text-sm font-semibold text-[#101828]">
          {t("title")}
        </h1>
        <p className="mt-1 text-sm text-[#475467]">{t("description")}</p>
        <Button
          asChild
          variant="primaryOutline"
          className="mt-6 h-10 px-5 text-sm"
        >
          <Link href="/">
            <ArrowLeft className="!h-4 !w-4" />
            {t("action.return_home")}
          </Link>
        </Button>
      </div>
    </main>
  );
}
